import { server } from './index'

let juridicalApi = {
  all(id) {
    return server.get(`/user/available/juridical/${id}`)
  },
}

export { juridicalApi }
